import {FC, useState} from "react";
import {StaticImageData} from "next/image";
import {motion} from 'framer-motion';
import {TechnologyIcon} from "@components/sections/technologies/technology-icon";
import Swift from "@images/icons/swift.webp";
import Java from "@images/icons/java.webp";
import Spring from "@images/icons/spring.webp";
import Ktor from "@images/icons/ktor.webp";
import Kotlin from "@images/icons/kotlin.webp";
import Php from "@images/icons/Php.webp";
import Laravel from "@images/icons/Laravel.webp";
import Python from "@images/icons/Python.webp";
import Django from "@images/icons/Django.webp";
import FastApi from "@images/icons/fastapi.webp";
import Flask from "@images/icons/flask.webp";
import NodeJS from "@images/icons/Nodejs.webp";
import ReactIcon from "@images/icons/React.webp";
import NextJS from "@images/icons/NextJs.webp";
import Vue from "@images/icons/Vue.webp";
import Nuxt from "@images/icons/Nuxt.webp";
import * as jsdom from "jsdom";

const frontend_services: Array<{ id: number; image: StaticImageData, text: string }> = [{
    id: 1, image: ReactIcon, text: "React"
}, {
    id: 2, image: NextJS, text: "Next.js"
}, {
    id: 4, image: Vue, text: "Vue"
}, {
    id: 5, image: Nuxt, text: "Nuxt.js"
},];
const backend_services: Array<{ id: number; image: StaticImageData, text: string }> = [{
    id: 1, image: Php, text: "Php"
}, {
    id: 2, image: Laravel, text: "Laravel"
}, {
    id: 3, image: Python, text: "Python"
}, {
    id: 4, image: Django, text: "Django"
}, {
    id: 5, image: Flask, text: "Flask"
}, {
    id: 6, image: FastApi, text: "Fast Api"
}, {
    id: 7, image: NodeJS, text: "Node.js"
}, {
    id: 8, image: Java, text: "Java"
}, {
    id: 9, image: Spring, text: "Spring"
}, {
    id: 10, image: Kotlin, text: "Kotlin"
}, {
    id: 11, image: Ktor, text: "Ktor"
},];
const mobile_services: Array<{ id: number; image: StaticImageData, text: string }> = [{
    id: 1, image: ReactIcon, text: "React Native"
}, {
    id: 2, image: Ktor, text: "Ktor"
}, {
    id: 3, image: Kotlin, text: "Kotlin"
}, {
    id: 4, image: Swift, text: "Swift"
},];
export const Technologies: FC = ({}) => {
    const [activeTab, setActiveTab] = useState<string>("frontend-services")
    return (<>
        <div className="flex flex-wrap justify-center mt-4">
            <button onClick={() => setActiveTab('mobile-services')}
                    className={`${activeTab === "mobile-services" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
            Mobile Development
            </button>
            <button onClick={() => setActiveTab('backend-services')}
                    className={`${activeTab === "backend-services" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                Server Development
            </button>
            <button onClick={() => setActiveTab('frontend-services')}
                    className={`${activeTab === "frontend-services" ? 'bg-crowlyn' : 'bg-crowlyn-button'} hover:bg-crowlyn hover:text-white text-white rounded-xl text-base sm:text-xl md:text-base px-3 py-2 my-2 mx-2 text-center`}>
                Frontend Development
            </button>
        </div>
        {activeTab === "backend-services" && <motion.div
            className="flex flex-row flex-wrap justify-center"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{
                duration: 2, ease: "easeIn"
            }}
            id={"backend-services"}>
            {backend_services.map((backend_service: any) => (
                <TechnologyIcon key={`backend-services` + backend_service.id} image={backend_service.image}
                                title={backend_service.text}/>))}
        </motion.div>}
        {activeTab == "frontend-services" && <motion.div
            className="flex flex-row flex-wrap justify-center"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{
                duration: 2, ease: "easeIn"
            }}
            id={"frontend-services"}>
            {frontend_services.map((frontend_service: any) => (
                <TechnologyIcon key={`frontend-services` + frontend_service.id} image={frontend_service.image}
                                title={frontend_service.text}/>))}
        </motion.div>}
        {activeTab == "mobile-services" && <motion.div
            className="flex flex-row flex-wrap justify-center"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{
                duration: 2, ease: "easeIn"
            }}
            id={"mobile-services"}>
            {mobile_services.map((mobile_service: any) => (
                <TechnologyIcon key={`mobile-services` + mobile_service.id} image={mobile_service.image}
                                title={mobile_service.text}/>))}
        </motion.div>}
    </>);
};
